export const instanceURL = 'https://{{CONNECT_NAME}}.my.connect.aws/ccp-v2/';
export const INCIDENT = 'incident';

